export default "__VITE_ASSET__xXiMLs29__"